import axios from "axios";
import { GetReferenceType, PaymentReferenceType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { AUTH_LOCALSTORAGE, BASE_URL, GENERATOR_REFERENCE_CODE, PAYMENT_REFERENCES, UPLOAD_PAYMENT_REFERENCES_FILE } from "../../utils/constants";
import { is } from "cypress/types/bluebird";

export const createPaymentReference = async (data: PaymentReferenceType) => await post<PaymentReferenceType, string>(PAYMENT_REFERENCES, data);
export const updatePaymentReference = async (data: PaymentReferenceType) => await put<PaymentReferenceType, string>(PAYMENT_REFERENCES, data);

export const getPaymentReference = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    if (data?.IdPaymentType) {
        queryParams.append('IdPaymentType', data.IdPaymentType);
    }
    if (data?.IdStudentDebt) {
        queryParams.append('IdStudentDebt', data.IdStudentDebt);
    }
    if (data?.IdStudent) {
        queryParams.append('idStudent', data.IdStudent);
    }
    const url = `${PAYMENT_REFERENCES}?${queryParams.toString()}`;
    return await get<PagedResultsType<PaymentReferenceType>>(url)
};
export const getReferenceCode = async () => {
  
    const url = `${GENERATOR_REFERENCE_CODE}`;
    return await get<string>(url)
};

export const getReferenceCodeV2 = async (data:GetReferenceType) => {
    const url = `${GENERATOR_REFERENCE_CODE}`;
    return await post<GetReferenceType, string>(url, data)  
};

export const uploadPaymentFile = async (formData: FormData)=> await post<any,any>(UPLOAD_PAYMENT_REFERENCES_FILE, formData, true);

